var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23138 13.8131L7.64743 11.0367H4.80662C4.59269 11.0367 4.38753 10.9517 4.23626 10.8005C4.08498 10.6492 4 10.444 4 10.2301V3.80662C4 3.59269 4.08498 3.38753 4.23626 3.23626C4.38753 3.08498 4.59269 3 4.80662 3H12.3018C12.4077 2.99995 12.5126 3.02078 12.6105 3.0613C12.7084 3.10182 12.7973 3.16124 12.8722 3.23615C12.9472 3.31106 13.0066 3.4 13.0471 3.49789C13.0876 3.59577 13.1084 3.70068 13.1084 3.80662V8.06849H11.4791C10.885 8.06858 10.3151 8.30442 9.89474 8.72422C9.47434 9.14403 9.23769 9.71349 9.23674 10.3076L9.23138 13.8131Z",
    fill: "white",
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9723 10.9654C12.7231 10.9654 12.4841 11.0644 12.3078 11.2407C12.1316 11.4169 12.0326 11.6559 12.0326 11.9051V17.7955C12.0326 18.0447 12.1316 18.2837 12.3078 18.46C12.4841 18.6362 12.7231 18.7352 12.9723 18.7352H15.5044L17.3447 21.9639V18.7336H19.645C19.8942 18.7336 20.1332 18.6346 20.3094 18.4584C20.4857 18.2822 20.5847 18.0432 20.5847 17.7939V11.9036C20.5847 11.6543 20.4857 11.4153 20.3094 11.2391C20.1332 11.0629 19.8942 10.9639 19.645 10.9639H12.9723",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9723 10.9654C12.7231 10.9654 12.4841 11.0644 12.3078 11.2407C12.1316 11.4169 12.0326 11.6559 12.0326 11.9051V17.7955C12.0326 18.0447 12.1316 18.2837 12.3078 18.46C12.4841 18.6362 12.7231 18.7352 12.9723 18.7352H15.5044L17.3447 21.9639V18.7336H19.645C19.8942 18.7336 20.1332 18.6346 20.3094 18.4584C20.4857 18.2822 20.5847 18.0432 20.5847 17.7939V11.9036C20.5847 11.6543 20.4857 11.4153 20.3094 11.2391C20.1332 11.0629 19.8942 10.9639 19.645 10.9639H12.9723",
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationActive);
export default __webpack_public_path__ + "static/media/translation-active.e5f425ef.svg";
export { ForwardRef as ReactComponent };